import {
    CancelOrderConfirmationModalPortalProvider,
    CartItemDeleteConfirmationModalPortalProvider,
} from '@/features/pos'
import { EditAutomaticContainersModalPortalProvider } from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/contexts/Portal'
import { Provider as ProductConfigurationModalPortalProvider } from '@/features/pos/components/ProductConfigurationModal/contexts/Portal'
import ConfigurableProductIdProvider from '@/features/pos/contexts/ConfigurableProductId'
import { useScreenLayout } from '@/hooks/screen'
import { FC, ReactNode } from 'react'

interface LayoutWrapperProps {
    children: ReactNode
}

const LayoutWrapper: FC<LayoutWrapperProps> = ({ children }) => {
    const layout = useScreenLayout()

    if (layout === 'compact')
        return (
            <ConfigurableProductIdProvider>
                <ProductConfigurationModalPortalProvider>
                    <CartItemDeleteConfirmationModalPortalProvider>
                        <EditAutomaticContainersModalPortalProvider>
                            <CancelOrderConfirmationModalPortalProvider>
                                {children}
                            </CancelOrderConfirmationModalPortalProvider>
                        </EditAutomaticContainersModalPortalProvider>
                    </CartItemDeleteConfirmationModalPortalProvider>
                </ProductConfigurationModalPortalProvider>
            </ConfigurableProductIdProvider>
        )

    return (
        <ProductConfigurationModalPortalProvider>
            {children}
        </ProductConfigurationModalPortalProvider>
    )
}

export default LayoutWrapper
